import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '../pages/HomePage';
import ContactsPage from '../pages/ContactsPage';
import ExhibitPage from '@/pages/ExhibitPage';
import ArticlesPage from '@/pages/ArticlesPage';
import NewsPage from '@/pages/NewsPage';
import AllExhibitPage from '@/pages/AllExhibitPage.vue';
import ExhibitCreationPage from '@/pages/adminPages/ExhibitCreationPage';
import ArticleCreationPage from '@/pages/adminPages/ArticleCreationPage';
import newCreationPage from '@/pages/adminPages/NewCreationPage';
import PhotoInNatureCreation from '@/pages/adminPages/PhotoInNatureCreation';
import AuthPage from '@/pages/adminPages/AuthPage';
import CitationPage from '@/pages/CitationPage.vue';
import LabPage from '@/pages/LabPage';
import LabAboutPage from '@/pages/LabAboutPage';
import ServerStatusPage from "@/pages/adminPages/ServerStatusPage.vue";
import IndexAndGenusManagePage from "@/pages/adminPages/IndexAndGenusManagePage.vue";
import MainPage from "@/pages/MainPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/auth',
    component: AuthPage,
    meta: {
      title: 'Вход',
    },
  },
  {
    path: '/main',
    component: MainPage,
    meta: {
      title: 'Главная'
    }
  },
  {
    path: '/lab',
    component: LabPage,
    meta: {
      title: 'О лаборатории',
    },
  },
  {
    path: '/lab/about', component: LabAboutPage, meta: {
      title: 'О лаборатории',
    },
  },
  {
    path: '/collections', component: HomePage, meta: {
      title: 'Поиск образцов',
    },
  },
  {
    path: '/collections/:id', component: ExhibitPage, meta: {
      title: 'Об образце',
    },
  },
  {
    path: '/collections/:id/:species', name: 'AllExhibit', component: AllExhibitPage, meta: {
      title: 'Все образцы вида',
    },
  },
  {
    path: '/citation', component: CitationPage, meta: {
      title: 'Цитирование сайта',
    },
  },
  {
    path: '/contacts', component: ContactsPage, meta: {
      title: 'Контакты',
    },
  },
  {
    path: '/articles', component: ArticlesPage, meta: {
      title: 'Публикации',
    },
  },
  {
    path: '/news', component: NewsPage, meta: {
      title: 'Новости',
    },
  },
  {
    path: '/create/exhibit', component: ExhibitCreationPage, meta: {
      title: 'Добавление экземпляра',
    },
  },
  {
    path: '/manage/index-genus', component: IndexAndGenusManagePage, meta: {
      title: 'Управление индексами рода',
    },
  },
  {
    path: '/create/article', component: ArticleCreationPage, meta: {
      title: 'Добавление публикации',
    },
  },
  {
    path: '/create/new', component: newCreationPage, meta: {
      title: 'Добавление новости',
    },
  },
  {
    path: '/create/photo', component: PhotoInNatureCreation, meta: {
      title: 'Добавление фото вида',
    },
  },
  {
    path: '/server-status', component: ServerStatusPage, meta: {
      title: 'Состояние сервера',
    },
  },
  {
    path: '*', redirect: '/main', meta: {
      title: 'Гербарий-SV',
    },
  },
];

const vueRouter = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to,from, savedPosition) {
    return { x: 0, y: 0}
  }
});

vueRouter.beforeEach((to, from, next) => {
  document.title = to.meta?.title ?? 'Гербарий-SV';
  next();
});


export default vueRouter;